import { useState } from 'react'
import { message as $message } from 'antd'

import { queryCateActivity } from '@/services/distribution'

export default () => {
    const [categoryActivityData, setCategoryActivityData] = useState({
        children: [],
        config: {}
    })
    const [loading, setLoading] = useState(false)

    const loadCategoryActivityData = async params => {
        setLoading(true)
        const { success, data, message } = await queryCateActivity()
        if (success) {

            setCategoryActivityData(data)
        } else {
            $message.error(message)
        }
        setLoading(false)
    }

    return {
        loading,
        categoryActivityData,
        loadCategoryActivityData
    }
}
